<template>
  <CContainer fluid>
    <h3>Contratos de Arrendamiento</h3>
    <CCard class="mt-4">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="3">
            <CCallout color="info" class="m-0">
              <span class="text-muted">Equipos Arrendados</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-boxes text-info h2 mr-3"></i>
                <strong class="h4 align-middle">{{ numberRecords }}</strong>
              </div>
            </CCallout>
          </CCol>
          <CCol col="3">
            <CCallout color="info" class="m-0">
              <span class="text-muted">Valor Arrendamiento</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-cash-stack text-info h2 mr-3"></i>
                <strong class="h4 align-middle">${{ valueRentedProducts }}</strong>
              </div>
            </CCallout>
          </CCol>
          <CCol col="3">
            <CCallout color="warning" class="m-0">
              <span class="text-muted">Costo Arrendamiento</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-cash-coin text-warning h2 mr-3"></i>
                <strong class="h4 align-middle">${{ costRentedProducts }}</strong>
              </div>
            </CCallout>
          </CCol>
          <CCol col="3">
            <CCallout color="success" class="m-0">
              <span class="text-muted">Utilidad Arrendamiento</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-coin text-success h2 mr-3"></i>
                <strong class="h4 align-middle">${{ utilityRentedProducts }}</strong>
              </div>
            </CCallout>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mt-4">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="6">
            <CInput 
              label="Buscar:"
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord"
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" 
                  @click="() => {
                    searchWord = '';
                    getData(1);
                }">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" 
                  @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="6" class="d-flex justify-content-end align-items-center">
            <CButton
              color="success"
              :to="endpointAddRentContract">
              <i class="bi bi-plus-circle h4 mr-2"></i>
              <span>Agregar</span>
            </CButton>
            <CButton 
              color="dark" 
              variant="outline"
              class="ml-2"
              disabled
              :to="`${rootPath}/agregar`">
              <i class="bi bi-cloud-arrow-down h4 align-middle mr-2"></i>
              <span>Descargar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable
          hover
          class="table-hover-icons"
          responsive
          :items="rentContracts"
          :fields="fields"
          :items-per-page="itemsPerPage"
          @row-clicked="(item, index, _columnName, e) => {
            goToRentContract(item.id_ContratoArrendamiento)
          }">
          <template #documento="{item}">
            <td>
              <div>
                <h4>{{ item.numero }}</h4>
              </div>
              <div>
                <span>{{ item.prefijo }}</span>
              </div>
              <div v-if="item.estado == 'A'">
                <i class="bi bi-emoji-smile text-success h5 mr-1"></i>
                <span>Activo</span>
              </div>
              <div v-if="item.estado == 'I'">
                <i class="bi bi-emoji-frown text-danger h5 mr-1"></i>
                <span>Inactivo</span>
              </div>
            </td>
          </template>
          <template #empresa="{item}">
            <td>
              <div>
                <CIcon name="cil-building" class="mr-1" />
                <span>{{ item.directorio }}</span>
              </div>
              <div>
                <i class="bi bi-postcard mr-1"></i>
                <span>{{ item.identificacion }}</span>
              </div>
              <div>
                <i class="bi bi-person-workspace mr-1"></i>
                <span>{{ item.personal }}</span>
              </div>
            </td>
          </template>                    
          <template #estado="{item}">
            <td>
              <div>
                <CIcon name="cil-calendar" class="text-info mr-1" />
                <span>{{ item.fecha_Emision }}</span>
              </div>
              <div v-if="item.fecha_Vencimiento">
                <CIcon name="cil-calendar" class="text-s3orange mr-1" />
                <span>{{ item.fecha_Vencimiento }}</span>
              </div>
              <div>
                <i class="bi bi-folder-check text-s3yellow h5 mr-1"></i>
                <span>{{ item.cantidad_Productos }}</span>
              </div>
              <div v-if="item.tipo_Contrato == 'A'">
                <i class="bi bi-unlock h5 mr-1"></i>
                <span>Abierto</span>
              </div>
              <div v-if="item.tipo_Contrato == 'C'">
                <i class="bi bi-lock mr-1"></i>
                <span>Cerrado</span>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td class="d-flex justify-content-end">
              <div class="hover-actions">
                <a href="#" 
                  class="mr-3"
                  v-c-tooltip="'Borrar contrato'" 
                  @click="tryDelete($event, item.id_ContratoArrendamiento)">
                  <i class="bi bi-trash text-danger h4 hover-icon"></i>
                </a>
                <a href="#" 
                  class="mr-3"
                  v-c-tooltip="'Productos Arrendados'"
                  @click="goToRentedProducts(item.id_ContratoArrendamiento)">
                  <i class="bi bi-folder-plus text-s3yellow h4 hover-icon"></i>
                </a>
                <a href="#" 
                  class="mr-3"
                  v-c-tooltip="'Descargar Inventario'" 
                  @click="(e) => processRentedProducts(e, item.id_ContratoArrendamiento)">
                  <i class="bi bi-box-seam text-s3brown h4 hover-icon"></i>
                </a>
                <a href="#" 
                  class="mr-3"
                  v-c-tooltip="'Generar Pedido'"
                  @click="(e) => showPanelOrdersGeneration(e, item.id_ContratoArrendamiento)">
                  <i class="bi bi-receipt-cutoff text-success h4 hover-icon"></i>
                </a>
                <VerticalIconMenu
                  icon="bi bi-gear text-dark h4 hover-icon"
                  :class="['mr-3']"
                  :items="menuItems"
                  @select="onMenuSelected"
                />
                <a href="#">
                  <UserIcon class="text-s3yellow hover-icon" size="28" stroke-width="1.5"/>
                  <PackgeExportIcon class="text-dark hover-icon" size="28" stroke-width="1" />
                </a>
              </div>

                <!-- <a href="#" 
                  class="text-dark" 
                  @click="toggleDocument($event, item)">
                  <CIcon :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" class="text-dark" />
                </a> -->
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="mb-1" :show="item._toggled">
              <CRow>
                <CCol col="sm-12" class="d-flex justify-content-end">
                  <a href="#" 
                    class="mr-3"
                    v-c-tooltip="'Borrar contrato'" 
                    @click="tryDelete($event, item.id_ContratoArrendamiento)">
                    <i class="bi bi-trash text-danger h4"></i>
                  </a>
                  <a href="#" 
                    class="mr-3"
                    v-c-tooltip="'Agregar productos'"
                    @click="goToRentedProducts(item.id_ContratoArrendamiento)">
                    <i class="bi bi-folder-plus h4"></i>
                  </a>
                </CCol>
              </CRow>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)">
        </CPagination>  
      </CCardBody>

      <LoadingCover v-show="loading" />
    </CCard>

    <RightSidebar size="md" class="bg-s3grey" :show="showPanelProcessOrdersGeneration">
      <CContainer>
        <CCard class="mt-4">
          <CCardHeader class="bg-s3skyblue">
            <CCardTitle>
              Generaci&oacute;n Pedido y/o Factura de Venta
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="ordersFields">
            </VerticalDynamicForm>
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success"
                class="mr-2"
                @click="processOrdersGeneration()">
                <CIcon name="cil-check-circle" class="mr-2" />
                <span class="align-middle">Generar</span>
                <CSpinner 
                  size="sm" 
                  class="align-middle ml-2" 
                  v-show="loadingAction">
                </CSpinner>
              </CButton>
              <CButton 
                color="danger" 
                variant="outline"
                @click="showPanelProcessOrdersGeneration = false">
                <CIcon name="cil-x-circle" />
                <span class="align-middle mx-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSidebar>

  </CContainer>
</template>

<script>
  import { ref } from "vue";
  import CONSTANTS from "@/constants";
  import { 
    dividedValueToShow,
    toBase64
  } from "@/general";
  import { 
    dataGridContratosArrendamientos,
    crudContratoArrendamiento,
    resumenProductoArrendamiento,
    generaFacturacionContratoArrendamiento
  } from "@/apis/rents";

  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import RightSidebar from "@/components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";
  import VerticalIconMenu from "@/components/containers/VerticalIconMenu.vue";

  const fields = [
    { 
      key: "documento", 
      label: "Número",
      _style:"text-align:center;"
    },
    { 
      key: "empresa", 
      label: "Empresa",
      _style:"text-align:center;"
    },
    { 
      key: "estado", 
      label: "Estados",
      _style:"text-align:center;"
    },
    { 
      key: "acciones",
      label: "",
      _style:"text-align:center;"
    }
  ]

  export default {
    name: "RentContracts",
    data() {
      return {
        loading: false,
        loadingAction: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        fields,
        showPanelProcessOrdersGeneration: null,
        rentContracts: [],
        idSelectedRentContract: "",
        numberRecords: 0,
        valueRentedProducts: "",
        costRentedProducts: "",
        utilityRentedProducts: "",
        selectedRentedProductId: "",
        menuItems: [
          {
            id: 1,
            label: 'Dashboard',
            icon: 'bi bi-speedometer2'
          },
          {
            id: 2,
            label: 'Usuarios',
            icon: 'bi bi-people-fill'
          },
          {
            id: 3,
            label: 'Clientes',
            icon: 'bi bi-person-lines-fill'
          },
          {
            id: 4,
            label: 'Reportes',
            icon: 'bi bi-file-earmark-bar-graph'
          },
          {
            id: 5,
            label: 'Configuración',
            icon: 'bi bi-gear-fill'
          }
        ],
        ordersFields: [
          {
            key: "fechaInicial",
            label: "Fecha Inicial Liquidacion",
            value: "",
            type: "date",
            required: true,
            prepend_content: {
              name: "calendar2-check"
            }
          },
          {
            key: "fechaFinal",
            label: "Fecha Final Liquidacion",
            value: "",
            type: "date",
            required: true,
            prepend_content: {
              name: "calendar2-check"
            }
          },
          {
            key: "tipoDocumento",
            label: "Tipo Documento",
            value: "PE",
            type: "select",
            disabled: true,
            required: true,
            options: [
              { value: "", label: "Seleccionar" },
              { value: "PE", label: "Pedido" },
              { value: "FV", label: "Factura Venta" }
            ],
            prepend_content: {
              name: "journal-code"
            }
          },
          {
            key: "ordenCompra",
            label: "Orden de Compra",
            value: "",
            type: "text",
            prepend_content: {
              name: "patch-check"
            },
            custom_validation(value) {
              return value.length > 0 ? (value.length < 16 ? true : false) : true;
            }
          },
          {
            key: "fechaOrdenCompra",
            label: "Fecha Orden de Compra",
            value: "",
            type: "date",
            prepend_content: {
              name: "calendar-date"
            }
          },
          {
            key: "archivoAdjunto",
            label: "Archivo Adjunto:",
            value: "",
            type: "file",
            prepend_content: {
              name: "paperclip"
            }
          },
          {
            key: "commentario1",
            label: "Comentarios:",
            value: "",
            type: "text",
            prepend_content: {
              name: "chat-square-text"
            },
            custom_validation(value) {
              return value.length > 0 ? (value.length <= 100 ? true : false) : true;
            }
          },
          {
            key: "commentario2",
            label: "",
            value: "",
            type: "text",
            prepend_content: {
              name: "chat-square-text"
            },
            custom_validation(value) {
              return value.length > 0 ? (value.length <= 100 ? true : false) : true;
            }
          }
        ]
      }
    },
    components: {
      LoadingCover,
      RightSidebar,
      VerticalDynamicForm,
      VerticalIconMenu,
    },
    methods: {
      async getData(page, search) {
        this.loading = true

        try {
          this.searchWord = search
          const  { count, results } = await dataGridContratosArrendamientos(this, page, search)

          this.rentContracts = results;
          this.pageCount = parseInt(count / this.itemsPerPage);

          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }

        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar datos",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async getDataSummary() {
        const parameters = {
          "Id_ContratoArrendamiento": this.contractId
        }

        try {
          const { Cantidad, Valor_Arriendo, Valor_Costo } = await resumenProductoArrendamiento(this, parameters);

          this.numberRecords = Cantidad;
          this.valueRentedProducts = dividedValueToShow(Valor_Arriendo);
          this.costRentedProducts = dividedValueToShow(Valor_Costo);
          this.utilityRentedProducts = dividedValueToShow(Valor_Arriendo - Valor_Costo);
        } catch (error) {
          error
        }
      },
      goToRentContract(idRentContract) {
        idRentContract = idRentContract.replaceAll("-", "")

        this.$router.push({path: `${this.rootPath}/editar/${idRentContract}`})
      },
      goToRentedProducts(idRentContract) {
        idRentContract = idRentContract.replaceAll("-", "")

        this.$router.push({path: `${this.rootPath}/${idRentContract}/productosarrendamiento`});
      },
      tryDelete(e, idRentContract){
        e.preventDefault();
        e.stopPropagation();

        this.idSelectedRentContract = idRentContract

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteRentContract();
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
        });
      },
      async deleteRentContract() {
        this.loading = true;

        try {
          await crudContratoArrendamiento(this, "delete", this.idSelectedRentContract);

          this.getData();

          this.$store.commit("setAlert", {
            color: "success",
            message: "Acción exitosa",
            show: 5
          });
        } catch {
          this.$store.commit("setAlert", {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          });
        } finally {
          this.loading = false;
        }
      },
      processRentedProducts(e, rentContractId) {
        rentContractId

        e.preventDefault();
        e.stopPropagation();
        
        CONSTANTS.configSimpleConfirm.confirmButtonText = "Confirmar"
        // CONSTANTS.configSimpleConfirm.confirmButtonColor = "s3yellow"

        this.$confirm("¿Confirma que desea realizar un documento de salida de inventario de los productos del contrato de arrendamiento?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          // this.deleteRentContract();
          console.log();
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
        });
      },
      showPanelOrdersGeneration(e, rentContractId) {
        e.preventDefault();
        e.stopPropagation();

        this.clearFormOrdersGeneration();
        
        this.showPanelProcessOrdersGeneration = true;
        this.idSelectedRentContract = rentContractId;
      },
      async processOrdersGeneration() {
        this.loadingAction = true;

        const fileName = this.ordersFields[5].value ? this.ordersFields[5].value[0].name : null;
        const attachmentFile = this.ordersFields[5].value ? await toBase64(this.ordersFields[5].value) : null;
        const request = {
          "Tipo_Documento": this.ordersFields[2].value,
          "Id_ContratoArrendamiento": this.idSelectedRentContract,
          "Fecha_Inicial_Periodo": this.ordersFields[0].value ? this.ordersFields[0].value : null,
          "Fecha_Final_Periodo": this.ordersFields[1].value ? this.ordersFields[1].value : null,
          "Id_Establecimiento": null,
          "Id_Dependencia": null,
          "Comentario_01": this.ordersFields[6].value ? this.ordersFields[6].value : null,
          "Comentario_02": this.ordersFields[7].value ? this.ordersFields[7].value : null,
          "Orden_Compra": this.ordersFields[3].value ? this.ordersFields[3].value : null,
          "Fecha_Orden_Compra": this.ordersFields[4].value ? this.ordersFields[4].value : null,
          "Nombre_Archivo": fileName,
          "Archivo_Base64": attachmentFile
        }

        try {
          const { errorCode, errorMessage, response } = await generaFacturacionContratoArrendamiento(this, request);

          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: `El Documento No. ${response.Numero} del Cliente: ${response.Cliente} se grabo correctamente!`,
              show: 5
            });
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: `El Documento No. ${response.Numero} del Cliente: ${response.Cliente} se grabo, aun asi se presento un error. Error: ${errorMessage}`,
              show: 5
            });
          }
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error: ${error.status} - ${error.data.errorCode} ${error.data.errorMessage}`,
            show: 5
          });
        } finally {
          this.loadingAction = false;
          this.showPanelProcessOrdersGeneration = false;
        }
      },
      clearFormOrdersGeneration() {
        this.ordersFields[0].value = "";
        this.ordersFields[1].value = "";
        this.ordersFields[2].value = "PE";
        this.ordersFields[3].value = "";
        this.ordersFields[4].value = "";
        this.ordersFields[5].value = "";
        this.ordersFields[6].value = "";
        this.ordersFields[7].value = "";
      },
      onMenuSelected(item) {
        console.log('Seleccionado:', item)
        if (item.id === 1) {
          this.$router.push({ path: '/dashboard' });
        }

        // Ejemplo:
        // this.$router.push('/usuarios')
      },
      toggleDocument(e, item) {
        e.preventDefault();
        e.stopPropagation();

        this.$set(item, "_toggled", !item._toggled)
        // this.$nextTick(() => {})
      }
    },
    setup() {
      const rootPath = ref("");
      const endpointAddRentContract = ref("");

      return {
        rootPath,
        endpointAddRentContract
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.endpointAddRentContract = `${this.rootPath}/agregar`;

      this.getData();
      this.getDataSummary();
    } 
  }
</script>
